var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "escape-key",
          rawName: "v-escape-key",
          value: _vm.close,
          expression: "close"
        }
      ],
      staticClass: "preview-container"
    },
    [
      _c("article-preview", {
        attrs: { id: _vm.articleId, previewContentType: _vm.previewContentType }
      }),
      _vm._v(" "),
      _vm.isMounted
        ? _c(
            "button",
            {
              staticClass: "close tooltip-close",
              attrs: { "aria-label": "プレビューを閉じる" },
              on: { click: _vm.close }
            },
            [_vm._v("×\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { ref: "scriptPool", staticStyle: { display: "none" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }